<template>
  <v-container>
    <v-row class="mb-0">
      <v-col>
        <admin-table type="calculated" :year="year" :years="years" :emails="emails" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AdminTable from "@/components/AdminTable";
export default {
  name: "App",
  props: ["year", "years", "emails"],
  components: { AdminTable },
};
</script>

<style>
.v-speed-dial {
  position: absolute;
}
.v-btn--floating {
  position: relative;
}
</style>